import {
  ConfirmErrorIcon,
  ConfirmInfoIcon,
  ConfirmSuccessIcon,
  ConfirmWarningIcon,
} from '@sharedCR/coreDesignSystem/icons';

import { ConfirmationModalType } from 'constants/confirmationDialog';

export const confirmationIconComponentsMap = {
  [ConfirmationModalType.INFO]: ConfirmInfoIcon,
  [ConfirmationModalType.WARNING]: ConfirmWarningIcon,
  [ConfirmationModalType.ERROR]: ConfirmErrorIcon,
  [ConfirmationModalType.SUCCESS]: ConfirmSuccessIcon,
};

export const PaperProps = {
  sx: {
    width: '500px',
    // Cap to the viewport (32px gutter each side) so the dialog never overflows a
    // phone-width screen — a fixed 500px clipped the buttons/text on iPhone
    // (e.g. the biometric "Stay signed in?" prompt rendered mostly cut off).
    maxWidth: 'min(500px, calc(100% - 64px))',
    borderRadius: ({ shape }) => shape.radius.l,
    boxShadow: ({ palette }) => palette.shadow.l,
  },
};

export const KEYBOARD_OPT_OUT_SELECTOR =
  'button, [role="combobox"], [role="listbox"], [role="option"]';

export const slotProps = {
  backdrop: {
    sx: {
      backgroundColor: ({ palette }) => palette.background.backdrop,
    },
  },
};
